// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"90bcb466","455":"0697db4f","977":"36f78cc7"}[chunkId] + ".chunk.js";
};